/** Created by azhou on 2019/3/19.*/
<template>
  <div>
    <ul class="list-item">
        <li class="w-50 list-item-col">{{Itemize.name}}</li>
        <li class="w-50 list-item-col">
            {{Itemize.start_time | formatTimestamp}} 至 {{Itemize.end_time | formatTimestamp}}
        </li>
        <li class="w-50 list-item-col">{{Itemize.day_num}}天{{Itemize.night_num}}晚</li>
        <li class="w-50 list-item-col">
            <div class="text-link ml-auto" @click="toEleMsg">{{Itemize.file}}</div>
        </li>
        <li class="w-50 list-item-col flex-column">
            <div>门市价/{{Itemize.price1}}</div>
            <div>采购商价/{{Itemize.price2}}</div>
            <div>订单雨价/{{Itemize.price3}}</div>
        </li>
        <li class="w-50 list-item-col">
            <span :class="Itemize.status == 1 ? 'text-success' : 'text-danger'">
                {{Itemize.status == 1 ? '启用中' : '已下架'}}
            </span>
        </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'ItemizeItinerary',
    props:{
      Itemize:{}
    },
    methods: {
        toEleMsg () {
            window.open(this.ImgPreUrl + this.Itemize.file,'_blank')
        },
    }
  }
</script>
